module.exports = __webpack_public_path__ + "static/media/hands.c1005f89.svg";